import React, { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useParams } from '@reach/router'

import { Button } from '@refera/ui-web'

import useRolePermission from '_/hooks/use-role-permission'
import { useDialog } from '_/hooks/use-dialog'

import { BUTTONS_ACTION } from '_/utils/constants/service-order'
import { CanDoButtonAction } from '_/utils/can-do-button-action'

import { getProvidersOrders } from '_/modules/provider/actions'
import { getBudgetTemplates } from '_/modules/budgetTemplate/actions'

import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'
import { ImportBudgetTemplateModal } from '../../../Modals/import-budget-template'

export default function ImportBudgetButton() {
  const { showDialog, closeDialog } = useDialog()
  const { serviceOrderId } = useParams()

  const dispatch = useDispatch()

  const { isTradesman, isSAAS } = useRolePermission()
  const { pathname } = useLocation()

  const isCreating = pathname.includes('/novo')
  const { isEditing, setLoading, isLoading } = useBudgetForm()

  const [isImportModelModalOpen, setIsImportModelModalOpen] = useState(false)
  const [serviceOrdersId, setServiceOrdersId] = useState()

  const canImportBudgetTemplate = CanDoButtonAction({
    nameButton: BUTTONS_ACTION.IMPORT_BUDGET_TEMPLATE,
    isBudgetRelated: true,
  })

  const isButtonVisible = useMemo(
    () => canImportBudgetTemplate && (isTradesman || isSAAS) && (isCreating || isEditing),
    [canImportBudgetTemplate, isTradesman, isSAAS, isCreating, isEditing]
  )

  const handleOpenModal = async () => {
    setLoading(true)

    try {
      const params = {
        newBudget: true,
        serviceOrderId,
      }

      dispatch(getBudgetTemplates())
      await dispatch(getProvidersOrders(params)).then(res => setServiceOrdersId(res))
    } catch (error) {
      setLoading(false)
      showDialog({
        type: 'error',
        subject: 'Erro ao buscar modelos de orçamento',
        labelApprove: 'Ok',
        onApprove: closeDialog,
      })
    } finally {
      setLoading(false)
      setIsImportModelModalOpen(true)
    }
  }

  if (!isButtonVisible) return null

  return (
    <>
      <Button onClick={handleOpenModal} color="primary" variant="secondary" disabled={isLoading}>
        Importar orçamento
      </Button>
      {isImportModelModalOpen && (
        <ImportBudgetTemplateModal
          closeModal={() => setIsImportModelModalOpen(false)}
          serviceOrderIds={serviceOrdersId}
        />
      )}
    </>
  )
}
